module.exports = __webpack_public_path__ + "static/img/index-nav-1.15571ee4.png";